module.exports = __webpack_public_path__ + "fromBrideToMother-we-y.16667379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-we-y.jpg
// module id = DcXk
// module chunks = 0